import { Button } from "@ebsco-ui/ebsco-ui";
import { faArrowDown } from "@fortawesome/pro-regular-svg-icons/faArrowDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { ROUTES } from "../../../../../constants";
import sharedMessages from "../../../../../shared-messages";
import { execute } from "../../../../store/merge";
import {
  getSourceAccountPuaId,
  getSourceUserMetadata,
  getSourceUsername,
  getTargetUserMetadata
} from "../../../../store/merge/validate";
import { getAccountDisplayName } from "../../../../store/personal-user";
import AccountCard from "../../account-card";
import StepContent from "../../step-content";
import ConfirmMergeModal from "../confirm-merge-modal";
import messages from "./result-messages";
import ValidationResultImage from "./validation.svg";

import "./result.scss";

const block = "result";

const Result = ({
  executeMerge,
  intl: { formatMessage },
  sourceAccountMetadata,
  sourceAccountUsername,
  sourceAccountPuaId,
  targetAccountMetadata,
  targetAccountUsername,
  location,
  history
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const handleMerge = () => {
    setIsOpen(false);
    executeMerge(sourceAccountPuaId);
  };
  const handleCancelClicked = () => {
    history.push(`${ROUTES.ACCOUNT_UPDATE}${location.search}`);
  };
  return (
    <StepContent
      stepTitle={formatMessage(sharedMessages.mergeAccounts)}
      imageUrl={ValidationResultImage}
    >
      <div className={block}>
        <p className={`${block}__information`}>
          <FormattedMessage
            {...messages.mergeAccountData}
            values={{
              sourceAccount: sourceAccountUsername,
              targetAccount: targetAccountUsername
            }}
          />
        </p>
        <div className={`${block}__account-cards`}>
          <AccountCard
            className="source-account"
            accountTypeMessageDescriptor={messages.secondaryAccount}
            email={sourceAccountUsername}
            metadata={sourceAccountMetadata}
          />
          <div className={`${block}__arrow-down`}>
            <FontAwesomeIcon icon={faArrowDown} />
          </div>
          <AccountCard
            className="target-account"
            accountTypeMessageDescriptor={messages.currentAccount}
            email={targetAccountUsername}
            metadata={targetAccountMetadata}
          />
        </div>
        <Button
          type="button"
          styleType="solid"
          className={`${block}__merge-account-button`}
          onClick={handleOpenModal}
        >
          <FormattedMessage {...messages.mergeAccount} />
        </Button>
        <Button
          type="button"
          styleType="text"
          className={`${block}__cancel-button`}
          onClick={handleCancelClicked}
        >
          <FormattedMessage {...sharedMessages.cancel} />
        </Button>
        <ConfirmMergeModal
          isOpen={isOpen}
          onClose={handleCloseModal}
          onConfirm={handleMerge}
          sourceAccountUsername={sourceAccountUsername}
        />
      </div>
    </StepContent>
  );
};

Result.propTypes = {
  sourceAccountMetadata: PropTypes.object.isRequired,
  targetAccountMetadata: PropTypes.object.isRequired,
  sourceAccountPuaId: PropTypes.string.isRequired,
  sourceAccountUsername: PropTypes.string.isRequired,
  targetAccountUsername: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  sourceAccountMetadata: getSourceUserMetadata(state),
  targetAccountMetadata: getTargetUserMetadata(state),
  sourceAccountPuaId: getSourceAccountPuaId(state),
  sourceAccountUsername: getSourceUsername(state),
  targetAccountUsername: getAccountDisplayName(state)
});

const mapDispatchToProps = { executeMerge: execute };

export { Result };
export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Result);
